<template>
  <div>
    <app-detail-header :title="'User Associate Org'"></app-detail-header>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <associateOrgsConfig></associateOrgsConfig>
      </div>
      <div class="col-lg-8 col-md-6 col-sm-12">
        <associateOrgsPanel></associateOrgsPanel>
      </div>
    </div>
  </div>
</template>
<script>
import AssociateOrgsConfig from "../../components/paywall/usage/AssociateOrgsConfig";
import AssociateOrgsPanel from "../../components/paywall/usage/AssociateOrgsPanel";
export default {
  data() {
    return {
      selectedInstitution: null,
    };
  },
  components: {
    associateOrgsConfig: AssociateOrgsConfig,
    associateOrgsPanel: AssociateOrgsPanel,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/users/UserAssociateOrg.vue